
import { buildSpectateStaticAssetUrl } from '~spa/Utils/Spectate';

export const getArticleImage = (filename, articleType = 'article') => {
    return buildSpectateStaticAssetUrl(`/upload/${articleType}/${filename}`);
};


/**
 * getDayHour calculates the difference in time and returns the apporipriate string
 * @param {*} timediff text of the time difference from BE
 * @param {*} t function for translations
 * @returns {string} Value in hours or days
 */
export const getDayHour = (timediff, t) => {

    let count = timediff === 0 ? 1 : timediff;

    if (timediff >= 24) {
        count = Math.floor(timediff / 24);

        return t('long_articles_widget.time_day_diff', {count});
    }

    return t('long_articles_widget.time_hour_diff', {count});
};
